export const archives = $axios => ({
  create: sheetId => $axios.$post(`/sheets/${sheetId}/archive`),
  delete: sheetId => $axios.$delete(`/sheets/${sheetId}/archive`),
});
